import { w3cwebsocket as W3CWebSocket } from 'websocket';

const BINANCE_WS_URL = 'wss://stream.binance.com:9443/ws';

// Debounce utility
const debounce = (func, wait) => {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
};

const initializePriceWebSocket = (symbols, onPriceUpdate) => {
  const streams = symbols.map(symbol => `${symbol.toLowerCase()}usdt@ticker`).join('/');
  const wsUrl = `${BINANCE_WS_URL}/${streams}`;

  const ws = new W3CWebSocket(wsUrl);

  // Debounce price updates to reduce Redux dispatches
  const debouncedOnPriceUpdate = debounce(onPriceUpdate, 500);

  ws.onopen = () => {
    console.log('Connected to Binance WebSocket for prices with streams:', streams);
  };

  ws.onmessage = (message) => {
    try {
      const data = JSON.parse(message.data);
      const symbol = data.s.replace('USDT', '').toLowerCase();
      const price = parseFloat(data.c);
      debouncedOnPriceUpdate({ symbol, price });
    } catch (err) {
      console.error('Error processing WebSocket message:', err);
    }
  };

  ws.onerror = (error) => {
    console.error('WebSocket error:', error);
  };

  ws.onclose = () => {
    console.log('Disconnected from Binance WebSocket. Attempting to reconnect...');
    setTimeout(() => initializePriceWebSocket(symbols, onPriceUpdate), 5000);
  };

  return ws;
};

export { initializePriceWebSocket };